import { render, staticRenderFns } from "./Druck.vue?vue&type=template&id=9b65df6e&scoped=true"
import script from "./Druck.vue?vue&type=script&lang=ts"
export * from "./Druck.vue?vue&type=script&lang=ts"
import style0 from "./Druck.vue?vue&type=style&index=0&id=9b65df6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b65df6e",
  null
  
)

export default component.exports